import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { LoginScreen } from '../components/auth/LoginScreen';
import { RegisterScreen } from '../components/auth/RegisterScreen';

export const AuthRouter = () => {
    return (
        <div className="auth__main">
            <div className="auth__box-container">
                <Switch>
                    <Route
                        exact
                        path="/JournalAppReact/auth/login"
                        component={LoginScreen}
                    />

                    <Route
                        exact
                        path="/JournalAppReact/auth/register"
                        component={RegisterScreen}
                    />

                    <Redirect to="/JournalAppReact/auth/login" />


                </Switch>
            </div>

        </div>
    )
}
